import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import {
  ApiException,
  BuyerUpsertDto,
  RetailClient,
} from 'src/WebApiController';

/**
 * @param isNewBuyer When true, the backend rejects the upsert with a 409 Conflict
 * if a buyer with the same email already exists. Set this for create-only flows.
 */
export function useUpsertBuyer(isNewBuyer = false) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (buyerUpsert: BuyerUpsertDto) => {
      return await new RetailClient(activeAccountWebClientConfig).upsertBuyer(
        buyerUpsert,
        isNewBuyer
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['GetSellerBuyersPaginated'] });
      queryClient.invalidateQueries({ queryKey: ['GetBuyerDetailByEmail'] });
      queryClient.invalidateQueries({ queryKey: ['GetBuyerCustomerBook'] });
    },
    onError: (err: ErrorTypes) => {
      // POS-8992: 409 Conflict = duplicate email, suppress the generic popup.
      if ((err as ApiException)?.status === 409) {
        return;
      }
      showErrorDialog('RetailClient.upsertBuyer', err as Error, {
        trackErrorData: {},
      });
    },
  });
}
